module.exports = __webpack_public_path__ + "img/step2_a_remove_bottom_conectors - Copy.a83a3be2.png";